module.exports = __webpack_public_path__ + "img/20200321104658282.9134d2a4.png";